import { createContext, useContext } from 'react';
import type { Theme } from '../app/settings';

/** The chosen look (Settings, Look), for components that draw differently in each. */
export const ThemeContext = createContext<Theme>('void');

export const useTheme = (): Theme => useContext(ThemeContext);
